import TagBoxHinhThucMienGiam from './TagBoxHinhThucMienGiam'
export default TagBoxHinhThucMienGiam;